import { Injectable } from '@angular/core';
import { ImportMasterStatus } from './models/pincard/importmasterstatus.model';

@Injectable()
export class ImportMasterStatusService {
  constructor() {}

  getListImportMasterStatus(): ImportMasterStatus[] {
    let statusList: ImportMasterStatus[] = [];
    statusList.push(new ImportMasterStatus(4, 'Đang kiểm tra'));
    statusList.push(new ImportMasterStatus(3, 'Đang nhập kho'));
    statusList.push(new ImportMasterStatus(2, 'Chưa nhập kho'));
    statusList.push(new ImportMasterStatus(1, 'Hoàn tất'));
    statusList.push(new ImportMasterStatus(0, 'Khóa'));

    return statusList;
  }
}
